export default function postCustomerResetPasswordSms(phoneNumber: string) {
  return fetch(`${global.API_v1}/auth/customer/reset-password/sms`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ phoneNumber })
  });
}
